import { renderer } from '../Renderer';
import Expression from './Expression';

class TextExpression extends Expression {

	node:Node;

	constructor( node:Node ) {
		super();
		this.node = node;
		this.template = node.nodeValue;
	}

	update( data:any, name?:string ) {
		this.node.nodeValue = renderer.render( this.template, data );
	}
}

export default TextExpression;
